// extracted by mini-css-extract-plugin
export default {"inputControl":"Time_inputControl__pvXYe","label":"Time_label__kWL6F","requiredMark":"Time_requiredMark__Xw5XM","inputField":"Time_inputField__Q4Hny"};